{
  "version": 1,
  "asset_id": "f57fb075-c3cd-4799-8b7c-7a21d86645c1",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/f57fb075-c3cd-4799-8b7c-7a21d86645c1/lap-band-removed-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/f57fb075-c3cd-4799-8b7c-7a21d86645c1/lap-band-removed-1200.webp",
  "original_filename": "lap-band-removed-1200.webp",
  "size": 90570,
  "content_type": "image/webp",
  "created_at": "2026-09-20T00:12:13Z"
}
